module.exports = __webpack_public_path__ + "static/media/QuizzAppMain.65e449ce.PNG";